import { createTheme } from "@mui/material/styles";
import { brandTokens, typographyTokens } from "@/theme/tokens";
import type { ThemeMode } from "@/theme/ThemeModeContext";

export const createAppTheme = (mode: ThemeMode) => createTheme({
  cssVariables: true,
  palette: {
    mode,
    primary: { main: brandTokens.orange, dark: brandTokens.orangeDark },
    secondary: { main: brandTokens.green },
    error: { main: brandTokens.red },
    info: { main: brandTokens.blue },
    background: {
      default: mode === "dark" ? brandTokens.darkCanvas : brandTokens.canvas,
      paper: mode === "dark" ? brandTokens.darkSurface : brandTokens.surface,
    },
    text: {
      primary: mode === "dark" ? brandTokens.darkInk : brandTokens.ink,
      secondary: mode === "dark" ? brandTokens.darkMuted : brandTokens.muted,
    },
    divider: mode === "dark" ? brandTokens.darkLine : brandTokens.line,
  },
  typography: {
    fontFamily: typographyTokens.fontFamily,
    htmlFontSize: 16,
    fontSize: 16,
    h1: { fontSize: typographyTokens.displaySize, lineHeight: 1.12, fontWeight: 850, letterSpacing: 0 },
    h2: { fontSize: typographyTokens.titleSize, lineHeight: 1.18, fontWeight: 850, letterSpacing: 0 },
    h3: { fontSize: typographyTokens.sectionTitleSize, lineHeight: 1.25, fontWeight: 800, letterSpacing: 0 },
    body1: { fontSize: typographyTokens.bodySize, lineHeight: typographyTokens.baseLineHeight },
    body2: { fontSize: typographyTokens.controlSize, lineHeight: 1.45 },
    caption: { fontSize: typographyTokens.captionSize, lineHeight: 1.35 },
    button: { textTransform: "none", fontWeight: 800, fontSize: typographyTokens.controlSize },
  },
  shape: { borderRadius: 12 },
  components: {
    MuiButton: {
      defaultProps: { disableElevation: true },
    },
    MuiPaper: {
      styleOverrides: {
        rounded: { borderRadius: 18 },
      },
    },
  },
});
